import { ReactNode } from 'react'
import cn from 'utils/cn'

const Badge = ({
  children,
  className
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <span
      className={cn([
        'text-white bg-dark-6 uppercase rounded-md px-2 text-center text-sm',
        className
      ])}
    >
      {children}
    </span>
  )
}

export default Badge
